<template>
  <div>
    <card v-loading="loading" :title="$t('emvCutOvers.pageSingle.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <emv-cut-over-details :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import EmvCutOverDetails from "src/components/EmvCutOver/EmvCutOverDetails";
import {mapActions, mapState} from "vuex";

export default {
  name: 'EmvCutOverPage',
  components: {
    EmvCutOverDetails
  },
  methods: {
    ...mapActions(['LoadEmvCutOver'])
  },
  computed: {
    ...mapState({
      loading: state => state.emv_cut_over.loading,
      details: state => state.emv_cut_over.data,
      error: state => state.emv_cut_over.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadEmvCutOver({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
